/** The sign-up consent boxes' state (see ConsentCheckboxes). */
export interface ConsentChoices {
  /** Terms & Conditions + Privacy Policy — required to continue. */
  terms: boolean;
  /** Marketing and awareness messages — optional, unticked by default. */
  marketing: boolean;
}

export const EMPTY_CONSENT: ConsentChoices = { terms: false, marketing: false };
